<template>
<div>
	<!-- <h1>AccountsContainer</h1> -->
	<router-view />
</div>
</template>

<script>
export default {
	name: "accounts-view",
	props: [ 'nodeId' ],
	created( )
	{
		console.log( "[AccountsContainer] CREATED" );
	},
};
</script>


// WEBPACK FOOTER //
// src/components/containers/AccountsContainer.vue